var _defs, _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkColorWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,51.88h0a10.9,10.9,0,0,1-7.71-18.59l8.63-8.63a1,1,0,0,1,1.41,1.41L12.72,34.7A8.9,8.9,0,0,0,19,49.88h0a8.82,8.82,0,0,0,6.28-2.6l10-10a1,1,0,0,1,1.41,0,1,1,0,0,1,0,1.42l-10,10A10.81,10.81,0,0,1,19,51.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.36,35.63a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.41l8.61-8.62a8.9,8.9,0,0,0,0-12.59,8.89,8.89,0,0,0-12.57,0l-8.62,8.61a1,1,0,0,1-1.41-1.41l8.62-8.62a10.89,10.89,0,0,1,15.4,15.41l-8.62,8.61A1,1,0,0,1,39.36,35.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,42a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.41l22-22a1,1,0,0,1,1.41,0,1,1,0,0,1,0,1.42l-22,22A1,1,0,0,1,19,42Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 60,
    height: 60
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkColorWhite);
export default __webpack_public_path__ + "static/media/Link_color_white.06deb9d69669d52e13e5a2da7dc45f3a.svg";
export { ForwardRef as ReactComponent };